// @greenlight-spec: 09-data-brokering.md#tier-1--service-account--static-credential
// @greenlight-spec: 15-database-schema.md#integrations
/**
 * A `multi_header` `value_from` of `secret.<field>` fills that header from one
 * named field of a vaulted JSON-object secret (Datadog's API key + application
 * key pair). Plain `secret` is the whole vaulted string.
 */
export const SECRET_FIELD_PREFIX = 'secret.';
export function isSecretFieldSource(valueFrom) {
    return valueFrom !== undefined && valueFrom.startsWith(SECRET_FIELD_PREFIX);
}
/**
 * The secret fields an `auth_inject` reads, in header order and de-duplicated;
 * empty when the credential is a single opaque string. Takes a stored
 * `auth_inject` as-is, so it tolerates any shape.
 */
export function secretFieldsOf(authInject) {
    const inject = authInject;
    if (inject?.kind !== 'multi_header' || !Array.isArray(inject.headers))
        return [];
    const fields = [];
    for (const header of inject.headers) {
        const valueFrom = typeof header?.value_from === 'string' ? header.value_from : undefined;
        if (!isSecretFieldSource(valueFrom))
            continue;
        const field = valueFrom.slice(SECRET_FIELD_PREFIX.length);
        if (!fields.includes(field))
            fields.push(field);
    }
    return fields;
}
/**
 * Parses a structured secret and returns each named field, or null when the
 * secret is not a JSON object carrying every field as a non-empty string. The
 * caller decides the error; nothing here echoes the secret.
 */
export function parseSecretFields(raw, fields) {
    let parsed;
    try {
        parsed = JSON.parse(raw);
    }
    catch {
        return null;
    }
    if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed))
        return null;
    const out = {};
    for (const field of fields) {
        const value = parsed[field];
        if (typeof value !== 'string' || value.length === 0)
            return null;
        out[field] = value;
    }
    return out;
}
/** Why a secret does not fit an `auth_inject` that reads named fields, or null when it fits. */
export function secretFieldsError(authInject, secret) {
    const fields = secretFieldsOf(authInject);
    if (fields.length === 0 || parseSecretFields(secret, fields) !== null)
        return null;
    return `secret must be a JSON object with a non-empty string for each of: ${fields.join(', ')}`;
}
export function composeSecretFields(values) {
    return JSON.stringify(values);
}
//# sourceMappingURL=secret-fields.js.map